import React, { useContext } from "react"; 
 import {
  Card,
  Button,
  Result,
} from "antd";

import { LinkOutlined } from "@ant-design/icons";
import liff from '@line/liff';
import { MainContext } from "../../../../contexts/main.jsx";
import LinkAccount from '../../../../components/LinkAccount.jsx'

const PageLiffKuberLink = () => {  

    const { authData } = useContext(MainContext);

    const RenderFormLinked = () => {
        console.log(authData.email)
        return (
            <Result
              icon={<LinkOutlined />}
              title="Linked"
              subTitle={`บัญชี line ของท่านได้ทำการ link กับ account ก่อนหน้านี้แล้ว`}
              extra={[
                <Button type="primary" block size="large" onClick={()=>{
                    liff.closeWindow();
                }}>
                  Close
                </Button>
              ]}
            />
        )
    }

    return (
        <LinkAccount liffId={'2007388746-kxz8w47Y'}>
          <Card className="mb-5" size={'small'}>
              <RenderFormLinked/>
          </Card>
        </LinkAccount>
    ); 
};

export default PageLiffKuberLink;

